import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { XCircle } from "lucide-react";

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-dreamy flex items-center justify-center p-4">
      <Card className="p-8 max-w-md w-full text-center">
        <XCircle className="h-12 w-12 text-orange-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-2">Payment cancelled</h2>
        <p className="text-muted-foreground mb-6">
          Your payment was cancelled. No charges were made.
        </p>
        <div className="flex gap-4 justify-center">
          <Button variant="outline" onClick={() => navigate("/")}>
            Go to Home
          </Button>
          <Button onClick={() => navigate(-1)}>
            Try Again
          </Button>
        </div>
      </Card>
    </div>
  );
};

